import { alpha, createTheme } from '@mui/material/styles';
import { svSE } from '@mui/material/locale';
import { Colors } from 'src/shared/components/styles';

// clamp(min, preferred, max)
export const NAV_WIDTH = 'clamp(340px, 20vw, 360px)';
export const FEED_WIDTH = 'clamp(340px, 20vw, 368px)';
export const MAIN_CONTENT_WIDTH = 'clamp(840px, 60vw, 1400px)';
export const SHELL_MAX_WIDTH = 'clamp(1100px, 90vw, 1800px)';
export const SHELL_TOP_GAP = 36;

export const APPBAR_Z_INDEX = 1301;

export const createAppTheme = (companyColor?: string) =>
  createTheme(
    {
      palette: {
        text: {
          primary: Colors.GRAY_DARK,
          secondary: companyColor ?? Colors.PETROL,
        },
        primary: { main: companyColor ?? Colors.PETROL },
        secondary: {
          main: companyColor ? alpha(companyColor, 0.6) : Colors.PETROL_SOFT,
        },
        error: { main: Colors.RED },
        warning: { main: Colors.ORANGE },
        info: { main: Colors.YELLOW },
        success: { main: Colors.GREEN_SOFT },
        background: { paper: Colors.WHITE, default: Colors.GRAY_FAIR },
      },
      typography: {
        h4: { fontSize: 19, color: Colors.GRAY_DARK, fontWeight: 500 },
        h5: { fontSize: 17, fontWeight: 500 },
        h6: { fontSize: 15, fontWeight: 600 },
        subtitle1: {
          fontSize: 13,
          color: Colors.GRAY_DARK,
          fontWeight: 500,
        },
        subtitle2: {
          fontSize: 14,
          color: companyColor ?? Colors.PETROL,
          fontWeight: 500,
        },
        body2: { fontSize: 14, lineHeight: 1.5 },
        button: { textTransform: 'none' },
        fontFamily: [
          'Open Sans',
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          'sans-serif',
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
        ].join(','),
      },
      components: {
        MuiAppBar: {
          styleOverrides: {
            root: {
              zIndex: APPBAR_Z_INDEX, // > theme.zIndex.drawer (1200)
            },
          },
        },
        MuiCssBaseline: {
          styleOverrides: {
            html: { height: '100%' },
            body: {
              height: '100%',
              overflow: 'auto',
              '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
                backgroundColor: 'transparent',
                width: '8px',
              },
              '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
                borderRadius: 8,
                backgroundColor: 'rgba(0, 0 ,0 , 0.3)',
                minHeight: 24,
                width: '8px',
              },
              '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus':
                { backgroundColor: 'rgba(0, 0 ,0 , 0.5)' },
              '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active':
                { backgroundColor: 'rgba(0, 0 ,0 , 0.5)' },
              '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover':
                { backgroundColor: 'rgba(0, 0 ,0 , 0.5)' },
              '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
                backgroundColor: 'transparent',
              },
              '& .MuiBackdrop-root': {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
            },
            '#root': { height: '100%' },
          },
        },
      },
    },
    svSE,
  );
